"use client";
import React, { useEffect } from 'react';
import styled from "styled-components";
import { useSearchParams } from "next/navigation";
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext";
import { useMyContext } from "@/app/utils/MyContext";
import _, { keyBy } from 'lodash';
import FixtureList from "./list";
import styles from "@/app/page.module.css";
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";
import Footer from "@/app/ui/footer";
import BottomBanner from "@/app/ui/BottomBanner/bottombanner";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import dayJS, {dateFormat, toDate}  from '@/app/utils/DayJS';
import { theme, getSearchParams, adobeData, generateAdobeDataRaceNo, getAdditionalInfoForFixture } from "@/app/utils/Common";
import { SeasonHighlights } from "./seasonHighlights";
import { getBusinessDate, getFixtureList, getHomeBasicInfo } from "@/app/utils/request/requestList";

import "@/app/style/comm.scss";
import "@/app/style/simulcastfixture.scss";
import { raceTemplate } from '@/app/utils/constant/template';
import Loading from "@/app/ui/Common/Loading";
import { TopBanner } from '../TopBanner/banner';

const Container = styled.div<{ ismobile?: string }>`
  margin-bottom: 12px;
  ${({ ismobile }) =>
    ` 
  margin: ${ismobile == "true" ? "0 8px" : ""} ;
  `}
`;
const Wrapper = styled.div<{ ismobile?: string }>`
  width: 100%;
  background-color: white;
  border-radius: 4px;
  ${({ ismobile }) =>
    `box-shadow: ${ismobile == "true" ? "none" : "0px 2px 10px 0px rgba(0, 0, 0, 0.1)"};`
  }
`;

const SimulcastFixture: React.FC = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  const { state: myContextState, dispatch: myContextDispatch } = useMyContext();
  const { state: lang, dispatch: langDispatch } = useLanguage();
  const { t } = lang;
  const [fixtureConfig, setFixtureConfig] = React.useState<any>({});
  const [fixtureList, setFixtureList] = React.useState<IFixture[]>([]);
  const [seasonList, setSeasonList] = React.useState<string[]>([]);
  const { y, b_cid } = getSearchParams(new URLSearchParams(window.location.search));

  const [loading, setLoading] = React.useState<any>(true);
  let season: string | undefined = undefined;

  if (y) {
    let params = y?.split("/") || [];
    if (params.length) {
      season = params[0];
      season = season?.slice(0, 2) + "_" + season?.slice(2);
    }
  }

  const fetchFixtureData = () => {
    getFixtureList(lang.langCode, false, season)
      .then((res: any) => {
        let newList = res?.data?.fixtureList || []
        newList = newList.map((f: IFixture, index: string) => {
          // add raceDatetime from meeting level to fixture list by meeting mapping field
          const additData = getAdditionalInfoForFixture(lang.langCode, f, "-Fixture_Race");
          const newObj = {
            ...f,
            ...additData,
          }
  
          return newObj
        });
        setFixtureConfig(res?.config);
        setFixtureList(newList);
        setSeasonList(res?.data?.seasonList);
      })
      .catch((e: any) => {
        console.log(e);
      }).finally(() => {
        setTimeout(() => {
          setLoading(false)
        }, 300);
      });
  }

  useEffect(() => {
    setTimeout(() => {
      adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "pageview", {
        pageId: "racing/simulcast",
        internalAd: b_cid
      });
    }, 500);
    fetchFixtureData();
  }, []);

  return (
    <>
    <main className={styles.main}>
      <Header />
      <HeaderNav />
      <TopBanner isMobile={isMobile} /> 
      <div className="commBContent" style={{ padding: isMobile ? "" : "0 16px" }}>
        <Box className="fixtureTab">
          <Container ismobile={isMobile.toString()}>
            <Wrapper ismobile={isMobile.toString()}>
              {
                loading ? <Loading/> :<>
                  <FixtureList isMobile={isMobile} fixtureList={fixtureList} fixtureConfig={fixtureConfig} />
                  {seasonList.length && <SeasonHighlights seasonList={seasonList} /> || <></>}
                  
                </>
              }
             
            </Wrapper>
          </Container>
          <div style={{ margin: isMobile ? "8px" : "" }}>{t("Fixture_Racecard_change_remarks")}</div>
          <BottomBanner></BottomBanner>
        </Box>
      </div>
      <Footer />
    </main>
    </>
  );
};
export default SimulcastFixture;
